import moment from "moment";

export const formatDate = (
  date?: Date,
  from = "YYYY-MM-DD",
  to = "DD/MM/YYYY"
) => {
  return date ? moment(date, from).format(to) : "";
};

export const compareDates = (date1?: Date, date2?: Date) => {
  if (!date1 || !date2 || isNaN(date1?.getTime()) || isNaN(date2?.getTime())) {
    return -2;
  }
  if (
    moment(date1).format("DD/MM/YYYY") === moment(date2).format("DD/MM/YYYY")
  ) {
    return 0;
  }
  return date1 < date2 ? -1 : 1;
};

export const mergeDateAndTime = (date: string, time: string): string | null => {
  const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;
  if (!dateRegex.test(date)) {
    console.log("Invalid date format. Expected dd/mm/yyyy");

    return null;
  }

  const [day, month, year] = date.split("/").map(Number);

  if (month < 1 || month > 12 || day < 1 || day > 31) {
    console.log("Invalid date values");
    return null;
  }

  const timeParts = time.split(":").map(Number);
  const hours = timeParts[0] || 0;
  const minutes = timeParts[1] || 0;
  const seconds = timeParts[2] || 0;

  const dateTime = new Date(year, month - 1, day, hours, minutes, seconds);

  return dateTime.toISOString();
};

export const splitDateTime = (
  isoString: string
): { date?: string; time?: string } => {
  const date = new Date(isoString);

  if (isNaN(date.getTime())) {
    console.log("Invalid ISO8601 date string");
    return {};
  }

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return {
    date: `${day}/${month}/${year}`,
    time: `${hours}:${minutes}`,
  };
};
